<template>
  <div class="rank">
    <div class="rank__header">
      <h4 class="rank__title">{{ title }}</h4>
      <span class="rank__meta">TOP {{ list && list.length ? list.length : 0 }}</span>
    </div>
    <ul class="list" v-if="list && list.length>0">
      <li :key="index" v-for="(item, index) in list">
        <span :class="index < 3 ? 'active' : null" class="rank__index">{{ index + 1 }}</span>
        <span class="rank__name">{{ item.name }}</span>
        <span class="rank__value">{{ item.total }}</span>
      </li>
    </ul>
    <no-data v-else></no-data>
  </div>
</template>

<script>
export default {
  name: 'RankList',
  props: {
    title: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: null
    }
  }
};
</script>

<style lang="scss" scoped>
.rank {
  padding: 0;
}

.rank__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.rank__title {
  margin: 0;
  color: #1f3147;
  font-size: 16px;
  font-weight: 700;
}

.rank__meta {
  color: #6b8198;
  font-size: 12px;
  font-weight: 600;
}

.list {
  margin: 0;
  padding: 14px 16px;
  list-style: none;
  border-radius: 22px;
  background:
    radial-gradient(circle at top right, rgba(174, 213, 235, 0.16), transparent 32%),
    linear-gradient(180deg, rgba(251, 253, 255, 0.98) 0%, rgba(243, 248, 252, 0.96) 100%);
  border: 1px solid rgba(120, 146, 176, 0.12);
}

.list li {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 0;
}

.list li + li {
  border-top: 1px solid rgba(120, 146, 176, 0.1);
}

.rank__index,
.rank__name,
.rank__value {
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  line-height: 22px;
}

.rank__index {
  flex: 0 0 24px;
  width: 24px;
  height: 24px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: #edf3f8;
  color: #6b8198;
  font-size: 12px;
  font-weight: 700;
}

.rank__index.active {
  background: linear-gradient(135deg, #4d8ac5 0%, #3e74ae 100%);
  color: #fff;
}

.rank__name {
  flex: 1;
  min-width: 0;
  color: #344d68;
}

.rank__value {
  color: #1f3147;
  font-weight: 700;
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.rank ::v-deep .no-data {
  padding: 18px 0;
}

.mobile .rank {
  padding: 0;
}

@media (max-width: 768px) {
  .rank__name {
    font-size: 13px;
  }

  .rank__value {
    font-size: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Charts/RankList.vue